import "../css/app.css";

import "./bootstrap";

import { mobileAppSetup } from "@/utils/appCommunication";

// @ts-expect-error - TS is upset about this import for some reason
import { Ziggy } from "@/ziggy.js";

import { appHost } from "@/utils/hosts";

/*
 * Ziggy's `route().current()` matches the browser's host against routes that
 * all live on the Laravel host, so on an SPA host nothing ever matches and it
 * returns undefined. Setting this as `location.host` on the Ziggy config makes
 * current() resolve as if the visitor were on the app host; pathname and
 * search still fall through to the live window.location, and URL generation
 * (`route("name")`) reads `config.url`, so neither is affected.
 *
 * On a host with no app host pair the input is returned unchanged, which keeps
 * current() behaving exactly as it does without the override.
 */
window.Ziggy = { ...Ziggy, location: { host: appHost() } };
globalThis.route = route;

import "@/utils/fun";
import "@/utils/openTabs";
import { QueryClientProvider } from "@tanstack/react-query";
import { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { route } from "ziggy-js";
import AppRouter from "./AppRouter";
import { RequiredProviders } from "./Contexts/RequiredProviders";
import { captureFirstTouch } from "./utils/activationSignals";
import { hasLoggedInMarker, identityQuery } from "./utils/identity";
import { queryClient } from "./utils/queryClient";
import { installRetryChunkImport } from "./utils/retryChunkImport";
import { trackIdentityEvents } from "./utils/spaAnalytics";
import { captureUtmParams } from "./utils/utmParams";

installRetryChunkImport();
mobileAppSetup();

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");

// Must run before the first render so /start can read the landing params it was
// navigated to with, rather than the post-redirect URL.
captureUtmParams();
captureFirstTouch();

trackIdentityEvents();

if (hasLoggedInMarker()) {
    void queryClient.prefetchQuery(identityQuery);
}

createRoot(rootElement).render(
    <QueryClientProvider client={queryClient}>
        <RequiredProviders>
            <Suspense fallback={null}>
                <AppRouter />
            </Suspense>
        </RequiredProviders>
    </QueryClientProvider>,
);
